import Alert from "@/components/atoms/Alert";

export const FormDisclaimer = ({
  disclaimer,
  t,
}: {
  disclaimer?: string;
  t: Record<string, string>;
}) => {
  if (!disclaimer) return null;

  return (
    <div className="u-grid-col-12">
      <Alert
        className="Step__disclaimer"
        type="warning"
        content={t[disclaimer]}
        showLeftIcon
      />
    </div>
  );
};
